import React from 'react';
import { Mail } from 'lucide-react';

const ProfileHeader = ({ user, email }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 mb-6">
      <div className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left gap-4 sm:space-x-6">
        <div className="h-16 w-16 sm:h-20 sm:w-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
          <span className="text-xl sm:text-2xl text-white font-semibold">
            {user.firstName[0]}{user.lastName[0]}
          </span>
        </div>
        <div>
          <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
            {user.firstName} {user.lastName}
          </h1>
          <p className="text-gray-500 flex items-center justify-center sm:justify-start mt-1">
            <Mail className="w-4 h-4 mr-2" />
            <span className="text-sm sm:text-base truncate">{email}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;